export interface AnnualEIT105060List {
    row?: string,
    name?: string,
    amount?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
}

let list: AnnualEIT105060List[] = [
    {
        name: "一、本年广告费和业务宣传费支出",
        row: "1",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "减：不允许扣除的广告费和业务宣传费支出",
        row: "2",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "二、本年符合条件的广告费和业务宣传费支出（1-2）",
        row: "3",
        amount: "",
        indent: 0,
        isEdit: true,
    },
    {
        name: "三、本年计算广告费和业务宣传费扣除限额的销售（营业）收入",
        row: "4",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "乘：税收规定扣除率",
        row: "5",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "四、本企业计算的广告费和业务宣传费扣除限额（4×5）",
        row: "6",
        amount: "",
        indent: 0,
        isEdit: true,
    },
    {
        name: "五、本年结转以后年度扣除额（3＞6，本行=3-6；3≤6，本行=0）",
        row: "7",
        amount: "",
        indent: 0,
        isEdit: true,
    },
    {
        name: "加：以前年度累计结转扣除额",
        row: "8",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：本年扣除的以前年度结转额[3＞6，本行=0；3≤6，本行=8与（6-3）孰小值]",
        row: "9",
        amount: "",
        indent: 0,
        isEdit: true,
    },
    {
        name: "六、按照分摊协议归集至其他关联方的广告费和业务宣传费（10≤3与6孰小值）",
        row: "10",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "按照分摊协议从其他关联方归集至本企业的广告费和业务宣传费",
        row: "11",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "七、本年广告费和业务宣传费支出纳税调整金额（3＞6，本行=2+3-6+10-11；3≤6，本行=2+10-11-9）",
        row: "12",
        amount: "",
        indent: 0,
        isEdit: true,
    },
    {
        name: "八、累计结转以后年度扣除额（7+8-9）",
        row: "13",
        amount: "",
        indent: 0,
        isEdit: true,
    },



]


let AnnualEIT105060 = list
export default AnnualEIT105060
